<template>
  <div class="px-12 pt-8">
    <div v-html="body" />
  </div>
</template>

<script>
import HomepageApi from '@/backend/HomepageApi';

export default {
  name: 'PublicCGU',
  data() {
    return {
      body: '',
    };
  },
  created() {
    HomepageApi.cgu().then(({ data }) => {
      this.body = data.content.body;
    });
  },
};
</script>
